"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/esnext.json.parse.js");
var _log = require("@/utils/log");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _SurveyImageInput = _interopRequireDefault(require("@/views/survey-builder/components/SurveyImageInput"));
var _SurveyMultipleTextbox = _interopRequireDefault(require("@/views/survey-builder/components/SurveyMultipleTextbox"));
var _SurveyMultipleOptionInput = _interopRequireDefault(require("@/views/survey-builder/components/SurveyMultipleOptionInput"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyPage',
  components: {
    SurveyImageInput: _SurveyImageInput.default,
    SurveyMultipleTextbox: _SurveyMultipleTextbox.default,
    SurveyMultipleOptionInput: _SurveyMultipleOptionInput.default
  },
  props: {
    pages: Array,
    isInUse: String
  },
  data() {
    if (this.pages.length > 0) {
      this.pages.forEach((page, index) => {
        this.addPropsToPage(page);
        page.label = 'Page ' + (index + 1);
        page.questions.forEach(question => {
          // If question has no "deletable" property, init question's "isDeletable" property
          if (!('isDeletable' in question)) {
            question.isDeletable = true;
          }
        });
      });
    }
    const defaultQuestionForm = {
      // _id: '',
      subcategory: [],
      questionFormat: 'text',
      questionTextObjects: [{
        value: ''
      }],
      // convert to questionText
      questionImgUrl: [],
      // temporarily fixed
      questionVideoUrl: [],
      // temporarily fixed
      answerFormat: '',
      answerOptions: [{
        value: '',
        label: ''
      }],
      // convert to answerOptions
      answerMaxValue: 10,
      answerMinValue: 1,
      minValueLabel: '',
      maxValueLabel: '',
      answerTextPlaceHolder: '',
      noOfTextbox: 7,
      buttonText: 'OK',
      // temporarily fixed
      buttonColor: '#0077b6',
      // temporarily fixed
      buttonTextColor: '#FFFFFF',
      // temporarily fixed
      isEnabled: 'Y',
      isRequired: 'Y',
      tags: []
    };
    return {
      validImageExtension: _lifehikesInitData.validImageExtension,
      // Page list
      currentPage: this.pages.length > 0 ? this.pages[0] : null,
      // Question Dialog
      questionDialogVisible: false,
      defaultQuestionForm,
      questionForm: JSON.parse(JSON.stringify(defaultQuestionForm)),
      questionFormRules: {
        questionFormat: [{
          required: true,
          message: 'Please select question format',
          trigger: 'blur'
        }],
        answerFormat: [{
          required: true,
          message: 'Please select answer format',
          trigger: 'blur'
        }]
      },
      editingQuestionIndex: null
    };
  },
  methods: {
    // public methods
    moveUp(list, index) {
      if (index === 0) {
        return;
      }
      const item = list.splice(index, 1)[0];
      list.splice(index - 1, 0, item);
    },
    moveDown(list, index) {
      if (index === list.length - 1) {
        return;
      }
      const item = list.splice(index, 1)[0];
      list.splice(index + 1, 0, item);
    },
    // Page list
    handleAddPage() {
      const newPage = {
        title: '',
        headerImg: '',
        // Questions
        questions: []
      };
      this.addPropsToPage(newPage);
      newPage.label = 'Page ' + (this.pages.length + 1);
      newPage.title = 'Page ' + (this.pages.length + 1);
      this.pages.push(newPage);
      this.currentPage = newPage;
    },
    handlePageClick(page) {
      this.currentPage = page;
    },
    handlePageDelete(index) {
      // When the current page is deleted
      if (this.pages[index] === this.currentPage) {
        this.currentPage = null;
      }
      this.pages.splice(index, 1);
      this.resetPageLabels();
    },
    handlePageMoveUp(pageIndex) {
      this.currentPage = this.pages[pageIndex];
      this.moveUp(this.pages, pageIndex);
      this.resetPageLabels();
    },
    handlePageMoveDown(pageIndex) {
      this.currentPage = this.pages[pageIndex];
      this.moveDown(this.pages, pageIndex);
      this.resetPageLabels();
    },
    addPropsToPage(page) {
      // Label in page list
      page.label = '';

      // If page has no "deletable" property, init page's "isDeletable" property
      if (!('isDeletable' in page)) {
        page.isDeletable = true;
      }

      // Upload Img properties
      page.thumbnailFile = null;
      page.showThumbnailUploadErrMsg = false;
    },
    resetPageLabels() {
      for (let i = 0, l = this.pages.length; i < l; i++) {
        this.pages[i].label = 'Page ' + (i + 1);
      }
    },
    // Question list
    handleAddQuestion() {
      this.questionDialogVisible = true;
    },
    handleEditQuestion(row, index) {
      const questionForm = JSON.parse(JSON.stringify(row));
      questionForm.questionTextObjects = questionForm.questionText.map(text => ({
        value: text
      }));
      delete questionForm.questionText;
      this.questionForm = questionForm;
      this.questionDialogVisible = true;
      this.editingQuestionIndex = index;
    },
    handleDeleteQuestion(questions, index) {
      questions.splice(index, 1);
    },
    // Qustion dialog
    handleMaxValueLabelChange(questionForm) {
      questionForm.maxValueLabel = questionForm.maxValueLabel.trim();
    },
    handleMinValueLabelChange(questionForm) {
      questionForm.minValueLabel = questionForm.minValueLabel.trim();
    },
    confirmQuestion() {
      this.$refs.questionForm.validate(valid => {
        if (valid) {
          // Modify data to match backend API
          const question = this.questionForm;
          question.questionText = question.questionTextObjects.map(obj => obj.value);
          delete question.questionTextObjects;

          // Init question's "isDeletable" property
          question.isDeletable = true;
          if (this.editingQuestionIndex === null) {
            this.currentPage.questions.push(question);
          } else {
            this.currentPage.questions.splice(this.editingQuestionIndex, 1, question); // Replace the original question
            this.editingQuestionIndex = null;
          }
          this.questionDialogVisible = false;
          this.questionForm = JSON.parse(JSON.stringify(this.defaultQuestionForm));
        }
      });
    },
    cancelQuestion() {
      if (this.editingQuestionIndex !== null) {
        this.editingQuestionIndex = null;
      }
      this.$refs.questionForm.clearValidate();
      this.questionDialogVisible = false;
      this.questionForm = JSON.parse(JSON.stringify(this.defaultQuestionForm));
    }
  }
};